import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { trackEvent, getUserPremiumStatus, getUserDetails } from '@surfline/web-common';
import { PromotionModal, userPropType } from '@surfline/quiver-react';
import { withCookies } from 'react-cookie';
import { OPEN_HOUSE_COOKIE } from '../../common/constants';

/**
 * PureComponent for handling the logic behind rendering the OpenHouse modal
 */
class OpenHouse extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    this.openOpenHouseModal();
  }

  /**
   * Retrieves the given openHouse cookie
   * @param {string} cookieName The name of the cookie
   */
  getOpenHouseCookie = (cookieName) => {
    const { cookies } = this.props;
    cookies.get(cookieName);
  };

  /**
   * Sets a cookie for when a user has viewed a given openHouse modal
   * @param {string} cookieName The name of the cookie
   * @param {number} cookieAge Max age of the cookie
   */
  setOpenHouseCookie = (cookieName, cookieAge) => {
    const { cookies } = this.props;
    cookies.set(cookieName, true, {
      path: '/',
      domain: location.hostname, // eslint-disable-line no-restricted-globals
      maxAge: cookieAge,
      expires: new Date(new Date().getTime() + cookieAge * 1000),
    });
  };

  trackModalOpen = () => {
    trackEvent('Showed Modal', {
      modalCategory: 'premium open house',
    });
  };

  /**
   * Opens the modal, and uses the callback to set the cookie
   */
  openModal = () => {
    const { openHouse } = this.props;
    this.setState(
      { isOpen: true },
      this.setOpenHouseCookie(OPEN_HOUSE_COOKIE, openHouse.promotionLength),
    );
    this.trackModalOpen();
  };

  closeModal = () => this.setState({ isOpen: false });

  /**
   * Function which holds the logic for opening the open house modal
   */
  openOpenHouseModal = () => {
    const { openHouse, isPremium } = this.props;
    const hasSeenOpenHouseModal = !!this.getOpenHouseCookie(OPEN_HOUSE_COOKIE);

    // If the user is not premium and open house is active
    if (!isPremium && openHouse.active === true && !hasSeenOpenHouseModal) {
      this.openModal();
    }
  };

  render() {
    const { isOpen } = this.state;
    const { openHouse, details } = this.props;

    return isOpen && openHouse && openHouse.data ? (
      <PromotionModal
        isOpen={isOpen}
        header={openHouse.data.modal.copy}
        description={openHouse.data.modal.description}
        sponsorName={openHouse.data.sponsorName}
        imageUrls={openHouse.data.modal.creative}
        onClose={this.closeModal}
        userDetails={details}
      />
    ) : null;
  }
}

OpenHouse.propTypes = {
  details: userPropType,
  openHouse: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    promotionLength: PropTypes.number,
    data: PropTypes.shape({
      sponsorName: PropTypes.string.isRequired,
      banner: PropTypes.shape({
        copy: PropTypes.string.isRequired,
        creative: PropTypes.shape({}).isRequired,
      }).isRequired,
      modal: PropTypes.shape({
        description: PropTypes.string.isRequired,
        copy: PropTypes.string.isRequired,
        creative: PropTypes.shape({}).isRequired,
      }).isRequired,
    }),
  }).isRequired,
  isPremium: PropTypes.bool,
  cookies: PropTypes.shape({
    get: PropTypes.func,
    set: PropTypes.func,
  }).isRequired,
};

OpenHouse.defaultProps = {
  details: null,
  isPremium: false,
};

export default connect((state) => {
  const excludeOpenHousePremium = true;
  return {
    details: getUserDetails(state),
    isPremium: getUserPremiumStatus(state, excludeOpenHousePremium),
  };
})(withCookies(OpenHouse));
